export enum AuthActionType {
  RESTORE_TOKEN = 'RESTORE_TOKEN',
  LOGIN = 'LOGIN',
  LOGIN_ERROR = 'LOGIN_ERROR',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGOUT = 'LOGOUT',
}
